<script>
import axios from 'axios'
import trans from '../mixins/trans'
import laroute from '../laroute'

export default {

    props: {
        initialDisabled: {
            type: Boolean,
            default: false
        },
        initialVatId: {
            type: String,
            default: ''
        }
    },

    mixins: [
        trans
    ],

    data() {
        return {
            disabled: this.initialDisabled,
            vatId: this.initialVatId,
            validated: false,
            validatedVatId: this.initialVatId,
            valid: null,
            traderName: '',
            traderAddress: ''
        };
    },

    computed: {
        countryCode() {
            return this.vatId.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().substring(0, 2);
        },

        vatNumber() {
            return this.vatId.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().substring(2);
        },

        company() {
            return this.traderName;
        },

        address() {
            return this.traderAddress.replace("\n", ' ⤷ ');
        }
    },

    methods: {
        validate() {
            let vatId = this.vatId.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            this.validatedVatId = vatId;
            if (vatId) {
                let url = laroute.route('vatid.validate', {'vatid': vatId});
                axios.get(url)
                    .then(response => {
                        this.validated = true;
                        this.valid = response.data.valid;
                        this.traderName = this.valid && response.data.info.traderName ? response.data.info.traderName : '';
                        this.traderAddress = this.valid && response.data.info.traderAddress ? response.data.info.traderAddress : '';
                    });
            } else {
                this.validated = true;
                this.valid = false;
                this.traderName = '';
                this.traderAddress = '';
            }
        }
    },

    mounted() {
        this.validate();
    },

    watch: {
        initialVatId(val) {
            this.vatId = val;
            this.validate();
        }
    },

}
</script>
